import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,downloadExcelReports} from '../../services/index';
import { DatePicker,message,Collapse,Drawer, Radio,Checkbox,label,Input,Popover,Select, Button ,Tooltip,TimePicker,Affix,Timeline,Modal   } from 'antd';
import Datetime from "react-datetime";
import Moment from 'moment';
import {  DownloadOutlined } from '@ant-design/icons';
import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import left from '../../assets/images/icon/next.png';
import right from '../../assets/images/icon/return.png';
import person from '../../assets/images/icon/person.png';

const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

const now = new Date();
var yesterday = Datetime.moment().subtract(1, "day");

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}
const item_name = [];

const format = 'HH:mm a' ;
const dateFormat = 'DD-MM-YYYY';

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
	  super(props);

    var date, TimeType, hour, minutes, seconds, fullTime;
    date = new Date();
    hour = date.getHours();
    if(hour <= 11){TimeType = 'am';} else{ TimeType = 'pm';}
	//alert(TimeType);
    if( hour > 12 ){hour = hour - 12;}
    if( hour == 0 ){hour = 12;  }
    minutes = date.getMinutes();
     if(minutes < 10) { minutes = '0' + minutes.toString();}
     seconds = date.getSeconds();
     if(seconds < 10){seconds = '0' + seconds.toString();}
     this.time= hour.toString() + ':' + minutes.toString() + ' ' + TimeType.toString();





		this.state = {
			size: 'default',
			item_name: item_name,
			value: '',
			new_date: '',
			is_next:0,
			student: [],
			checkedList: defaultCheckedList,
			indeterminate: true,
			docx_loading: false,
			checkAll: false,
			today: '',
			school_list: [],
			currentDateTime: Date().toLocaleString(),
			add : 0,
			selectedDate: null,
			tag: '',
			total_student: 0,
			total_in: 0,
			total_out: 0,
			total_absent: 0,
			total_leave: 0,
			total_unmark: 0,
			student_absent: 0,
			student_leave: 0,
			student_unmark: 0,
			total_halfday: 0,
			selected_time:  this.time,
			program_list:[],
			checkedBoxes: [],
			division_list: [],
			attendance_type:'',
			division:'',
			timeline_details:[],
			permission: [],
			checked: false,
			timeline: false,
			addfollow: false,
			is_view: 0,

		}
		this.onChangechecked = this.onChangechecked.bind(this);
		this.handleSubmit_in = this.handleSubmit_in.bind(this);
		this.handleSubmit_out = this.handleSubmit_out.bind(this);
		this.handleSubmit_leave = this.handleSubmit_leave.bind(this);
		this.handleSubmit_halfday = this.handleSubmit_halfday.bind(this);
		this.handleSubmit_absent = this.handleSubmit_absent.bind(this);
		this.handleSubmit_unmark = this.handleSubmit_unmark.bind(this);
		this.nextdate = this.nextdate.bind(this);
		this.change_attendence = this.change_attendence.bind(this);
		this.change_division = this.change_division.bind(this);
		this.onChangeTime = this.onChangeTime.bind(this);
		this.onChangeTimeMobile = this.onChangeTimeMobile.bind(this);
	}

	change_attendence(event){
		setTimeout(() => {
			this.setState({attendance_type: event});
		}, 100);
        
		var app = {user_id : this.state.user_id,school_id:this.state.school_id,program_id:event}
		getData('erp/division_list_by_class',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						division_list: result['data'],
						division: result['data'][0]['id'],
					});
					setTimeout(() => {
						this.change_division(result['data'][0]['id']);
					}, 100);
				}else{
					this.setState({
						division_list: [],
					});
				}
			}
		});
     }
	 
	change_division(event){
		setTimeout(() => {
			this.setState({division: event});
		}, 100);
        
		setTimeout(() => {
			this.checkData();
		}, 100);
     }

	 openQuantity(e){
		this.setState({ attendance_type: e });
		setTimeout(() => {
			this.checkData();
		}, 100);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{


		var date = new Date();
		var  currentDate =
			 date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var permission = storedArray['data'][0]['permission'];
		var user_type = storedArray['data'][0]['type'];
		this.setState({
			user_id : storedArray['data'][0]['user_id'],
			school_id : storedArray['data'][0]['school_id'],
			currentDate : currentDate,
			permission : permission,
			user_type : user_type,
		});

		//this.setDate();
		this.checkData_();
		this.CurrentTime();
		}
		
	}

	setDate = (newDate) => {
		const date = newDate || new Date();
		this.setState({
		  selectedDate:
			 date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
		});

	  };

  getPreviousDate = () => {
    //const { selectedDate } = this.state
	
    //const currentDayInMilli = new Date(selectedDate).getTime()
    //const oneDay = 1000 * 60 *60 *24
    //const previousDayInMilli = currentDayInMilli - oneDay
    //const previousDate = new Date(previousDayInMilli)
	//console.log(this.state.currentDate);
	//console.log(selectedDate);
    this.setState({tag:'pre'});
	setTimeout(() => {
			this.checkData();
		}, 50);
  }

  getNextDate = () => {
    //const { selectedDate } = this.state

   // const currentDayInMilli = new Date(selectedDate).getTime()
    //const oneDay = 1000 * 60 *60 *24
   // const nextDayInMilli = currentDayInMilli + oneDay
   // const nextDate = new Date(nextDayInMilli)
	this.setState({tag:'nxt'});
	setTimeout(() => {
			this.checkData();
		}, 50);
  }

	checkData_(){
  	    if(localStorage.getItem('schoolData')){
			const date =  new Date();

			var  selectedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()

			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({
			 user_id : storedArray['data'][0]['user_id'],
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = storedArray['data'][0]['type'];
			var date_ = selectedDate;
			var app = {user_id : user_id,date : date_,attendance_type:this.state.attendance_type,school_id:school_id,type:type}
		    var app = {user_id : user_id,school_id:school_id,type:type}
			getData('erp/new_program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							program_list: result['data'],
							attendance_type: result['data'][0]['id'],
						});
						setTimeout(() => {
							this.change_attendence(result['data'][0]['id']);
						}, 100);
					}else{
						this.setState({
							program_list: [],
						});
					}
				}
			});
		}
	}

  checkData(){
  	    if(localStorage.getItem('schoolData')){
			this.setState({is_view: 0,school_list:[]});
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({
			 user_id : storedArray['data'][0]['user_id'],
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];

			

			var app = {user_id : user_id,date : this.state.selectedDate,attendance_type:this.state.attendance_type,school_id:school_id,division:this.state.division,tag:this.state.tag}

			getData('erp/attendance_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						const count = result['data']
						const lenght_ = count.length;
						this.setState({
							school_list: result['data'],
							selectedDate: result['current_date'],
							is_next: result['is_next'],
							new_date: result['new_date'],
							total_student: result['total_student'],
							total_in: result['total_in'],
							total_out: result['total_out'],
							total_absent: result['total_absent'],
							total_leave: result['total_leave'],
							total_unmark: result['total_unmark'],
							total_halfday: result['total_halfday'],
							is_view: 1
						});
						if(lenght_ > 0){
							this.setState({
										student_in: result['data'][0]['student_in'],
										student_out: result['data'][0]['student_out'],
										student_absent: result['data'][0]['student_absent'],
										student_leave: result['data'][0]['student_leave'],
										student_unmark: result['data'][0]['student_unmark'],
										student_halfday: result['data'][0]['student_halfday'],

									});
						}
					}else{
						this.setState({
							school_list: [],
							is_view: 1
						});
					}
				}
			});
	}
  }
	
	DateChange(date, dateString) {
	    this.setState({ new_date: dateString,selectedDate: dateString });
	    setTimeout(() => {
			this.checkData();
		}, 50);
	}	

  nextdate(){
		var add = this.state.add + 1
		var today = new Date(),
		date = today.getDate()+add+ '-' + (today.getMonth() + 1) + '-' + today.getFullYear();
		this.setState({
			current_date : date,
			add : add,

		});
  }

  handleSubmit_in =(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			if(this.state.checkedBoxes.length == 0){
				message.config({ top: 150});
				message.error('Please Select Student !!!',2);
			}else{
				var app = {
						school_id: this.state.school_id ,
						staff_id: this.state.user_id,
						user_id: this.state.checkedBoxes ,
						date : this.state.selectedDate,
						time : this.state.selected_time,
						attendance_type : this.state.attendance_type,
						division:this.state.division
				}
				getData('erp/attendance_in',app).then((result) => {
				if(result.status==400){
					alert(result.message);
					}
					if(result.status==200){
						message.config({ top: 150});
						if(this.state.attendance_type=="staff"){
						  message.success('Staff In Successfully',2);
						}
						else{
							message.success('Student In Successfully',2);
						}
						this.checkData();
						this.setState({ checkedBoxes: [],checked:false });
					}
				});
			}
	  }else{
		message.error('Please Login',2);
	  }

  }

  handleSubmit_out =(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			if(this.state.checkedBoxes.length == 0){
				message.config({ top: 150});
				message.error('Please Select Student !!!',2);
			}else{
				var app = {
							school_id: this.state.school_id ,
							user_id: this.state.checkedBoxes ,
							staff_id: this.state.user_id ,
							date : this.state.selectedDate,
							time : this.state.selected_time,
							attendance_type : this.state.attendance_type,
							division:this.state.division
				}
				getData('erp/attendance_out',app).then((result) => {
				if(result.status==400){
					alert(result.message);
				}
				if(result.status==200){
					message.config({ top: 150});
					if(this.state.attendance_type=="staff"){
					  message.success('Staff Out Successfully',2);
					}
					else{
						message.success('Student Out Successfully',2);
					}

					this.checkData();
					this.setState({ checkedBoxes: [],checked:false });
				  }
				});
			}
		
	  }else{
		message.error('Please Login',2);
	  }

  }

  handleSubmit_absent =(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			if(this.state.checkedBoxes.length == 0){
				message.config({ top: 150});
				message.error('Please Select Student !!!',2);
			}else{
				var app = {
					school_id: this.state.school_id ,
					user_id: this.state.checkedBoxes ,
					staff_id: this.state.user_id,
					date : this.state.selectedDate,
					time : this.state.selected_time,
					attendance_type : this.state.attendance_type,
					division:this.state.division
				}
				getData('erp/attendance_absent',app).then((result) => {
				if(result.status==400){
					alert(result.message);
				}
				if(result.status==200){
					message.config({ top: 150});
					if(this.state.attendance_type=="staff"){
						message.success('Staff Absent Successfully',2);
					}
					else{
						message.success('Student Absent Successfully',2);
					}
					this.checkData();
					this.setState({ checkedBoxes: [],checked:false });
				}
			  });
			}
		
		}else{
			message.error('Please Login',2);
		}

  }

  handleSubmit_leave =(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			if(this.state.checkedBoxes.length == 0){
				message.config({ top: 150});
				message.error('Please Select Student !!!',2);
			}else{
				var app = {
					school_id: this.state.school_id ,
					user_id: this.state.checkedBoxes ,
					date : this.state.selectedDate,
					staff_id: this.state.user_id ,
					time : this.state.selected_time,
					attendance_type : this.state.attendance_type,
					division:this.state.division
				}
				getData('erp/attendance_leave',app).then((result) => {
				if(result.status==400){
					alert(result.message);
				}
				if(result.status==200){
					message.config({ top: 150});
					if(this.state.attendance_type=="staff"){
						message.success('Staff Leave Successfully',2);
					}
					else{
						message.success('Student Leave Successfully',2);
					}
					this.checkData();
					this.setState({ checkedBoxes: [],checked:false });
				}
				});
			}
		
		}else{
			message.error('Please Login',2);
		}

  }

  handleSubmit_halfday =(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			if(this.state.checkedBoxes.length == 0){
				message.config({ top: 150});
				message.error('Please Select Student !!!',2);
			}else{
				var app = {
					school_id: this.state.school_id ,
					user_id: this.state.checkedBoxes ,
					date : this.state.selectedDate,
					staff_id: this.state.user_id ,
					time : this.state.selected_time,
					attendance_type : this.state.attendance_type,
					division:this.state.division
				}
				getData('erp/attendance_halfday',app).then((result) => {
				if(result.status==400){
					alert(result.message);
				}
				if(result.status==200){
					message.config({ top: 150});
					if(this.state.attendance_type=="staff"){
						message.success('Staff Leave Successfully',2);
					}
					else{
						message.success('Student Half Day Successfully',2);
					}
					this.checkData();
					this.setState({ checkedBoxes: [],checked:false });
				}
				});
			}
		
		}else{
			message.error('Please Login',2);
		}

  }

  handleSubmit_unmark =(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			if(this.state.checkedBoxes.length == 0){
				message.config({ top: 150});
				message.error('Please Select Student !!!',2);
			}else{
				var app = {
					school_id: this.state.school_id ,
					user_id: this.state.checkedBoxes ,
					date : this.state.selectedDate,
					staff_id: this.state.user_id ,
					time : this.state.selected_time,
					attendance_type : this.state.attendance_type,
					division:this.state.division
				}
				getData('erp/attendance_unmark',app).then((result) => {
				if(result.status==400){
					alert(result.message);
				}
				if(result.status==200){
					message.config({ top: 150});
					if(this.state.attendance_type=="staff"){
						message.success('Staff Unmark Successfully',2);
					}
					else{
						message.success('Student Unmark Successfully',2);
					}
					this.checkData();
					this.setState({ checkedBoxes: [],checked:false });
				}
				});
			}		
		}else{
			message.error('Please Login',2);
		}

  }

	onChangechecked(checkedValues) {
	  this.setState({ student: checkedValues });
	  this.checkData();
	}

	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };

	onChange = checkedList => {
		this.setState({
		  checkedList,
		  indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
		  checkAll: checkedList.length === plainOptions.length,
		});
	  };

  onCheckAllChange = e => {
		this.setState({
		  checkedList: e.target.checked ? plainOptions : [],
		  indeterminate: false,
		  checkAll: e.target.checked,
		});
	  };


	onChangeTime(time, timeString) {
		  this.setState({ selected_time: timeString });
	}

	onChangeTimeMobile(e) {
		  this.setState({ selected_time: e.target.value });
	}


	CurrentTime() {
                var date = new Date();
                var hours = date.getHours();
                var minutes = date.getMinutes();


                var newformat = hours >= 12 ? 'PM' : 'AM';


                hours = hours % 12;


                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;

				var time = hours + ':' + minutes + ' ' + newformat
				//alert(time);
                //document.getElementById("current_time").value = time ;
    }

	toggleChecked = () => {

		const checkedBoxes = [...this.state.checkedBoxes];
		var checkboxes = document.getElementsByName('checked_id[]');
		for (var i = 0; i < checkboxes.length; i++) {
			checkedBoxes.push(checkboxes[i].value);
		}
		this.setState({checkedBoxes,checked:true,selection_count:checkedBoxes.length});
		console.log(checkedBoxes);
    }

	toggleUnChecked = () => {
		const checkedBoxes = [...this.state.checkedBoxes];
		this.setState({checkedBoxes:[],checked:false,selection_count:0});
    }

  handleCheckbox = (e, s) => {

    const checkedBoxes = [...this.state.checkedBoxes];
    if(e.target.checked) {
		checkedBoxes.push(s)
    } else {
		const index = checkedBoxes.findIndex((ch) => ch === s);
		checkedBoxes.splice(index, 1);
    }
    this.setState({checkedBoxes,selection_count:checkedBoxes.length});
	}
	
	
	showModaltimeline = (id) => {
    this.setState({
	  enquiry_id:id,
      timeline: true,
    });
	var app = {user_id : this.state.user_id,id:id}
		getData('erp/attendance_timeline_details',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						timeline_details: result['data'],
					});
				}else{
					this.setState({
						timeline_details: [],
						
					});
				}
			}
		});
	};

    handleOktimeline = e => {
		console.log(e);
		this.setState({
		  timeline: false,
		  addfollow: false,
		});
   };

    handleCanceltimeline = e => {
		console.log(e);
		this.setState({
		  timeline: false,
		  addfollow: false,
		});
    };
	
	addfollowModal = (id) => {  
		this.setState({
		  addfollow: true
		});
	};

	addfollowOk = e => {
		console.log(e);
		this.setState({
		  addfollow: false,
		});
	};

	addfollowCancel = e => {
		console.log(e);
		this.setState({
		  addfollow: false,
		});
	};
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var app = {
				school_id: this.state.school_id,
				user_id: this.state.user_id,
				enquiry_id: this.state.enquiry_id,
				remark: this.state.remark,
			}
			getData('erp/add_attendance_followup',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error(result.message,2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Followup added',2);
					this.setState({ loading: false,addfollow: false,remark:''});
					this.checkData();
					this.getTimeline(this.state.enquiry_id);
				}
			})
		}
		else{
			message.error('Please Login',2);	
		}
	}
	
	getTimeline= (id) => {
		var app = {user_id : this.state.user_id,id:id}
		getData('erp/attendance_timeline_details',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						timeline_details: result['data'],
					});
				}else{
					this.setState({
						timeline_details: [],
						
					});
				}
			}
		});
	}
	
	DocumentReport = () => {
  	    if(localStorage.getItem('schoolData')){			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = this.state.user_id;
			var school_id = this.state.school_id;
			this.setState({ docx_loading: false})
			var app = {user_id : user_id,school_id:school_id}
			downloadExcelReports('Phpspreadsheet/export_attendance_timeline_reports',app,'student_attendance_timeline').then((result) => {
				let responseJson = result;
				this.setState({ docx_loading: false})
				if(responseJson){
					message.config({ top: 150});
					message.success('File Downloaded',2);	
					
					window.location.reload();
				}
			});
		}
	}


	render()

	{
	const lenght = this.state.checkedBoxes.length;
	const student_lenght = this.state.school_list.length;
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>

					  </div>
					);
		return (
			<div class="mobile_view">
			
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i>Attendance
								
								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> Attendance </li>
									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			<div id="main" class="bg-off" style={{'min-height': '550px'}}>
			 <div class="">


			<div class="desktop-view">
			 <div class="col-md-12 m12 no-padd">
				


			<div id="attendance" class="bg-off">
				<div class="card">
				<div class="card-body">
					<div class="col-md-12 mt-10">

						<div class="col-md-12 no-padd">
						<div class="row">
						<div class="col-md-3  s6 center no-padd">
							<div class="iq-card date_range form-group d-flex">
								<svg onClick={this.getPreviousDate} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" fill="rgba(70,70,70,1)"/></svg>
								
								{this.state.new_date !='' && (<>
								<DatePicker value={moment(this.state.new_date, dateFormat)} format={dateFormat} onChange={this.DateChange.bind(this)} className="att-fil-date"/>
								</>)}
								
								{(() => {
									if (this.state.is_next == '1') {
										return (
											<svg onClick={this.getNextDate} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" fill="rgba(70,70,70,1)"/></svg>
										)
									}
								})()}
							</div>

						</div>
						
						<div class="col-md-2 s4 text-center attendance pl-0 form-group">

							<Select value={this.state.attendance_type} className="m-select " onChange={this.change_attendence}>
							{this.state.program_list.map((list) => (
								<Select.Option value={list.id}>{list.name}</Select.Option>
							))}
							</Select>
						</div>

						<div class="col-md-2 s4 text-center attendance pl-0 form-group">

							<Select value={this.state.division} className="m-select " onChange={this.change_division}>
							{this.state.division_list.map((list) => (
								<Select.Option value={list.id}>{list.name}</Select.Option>
							))}
							</Select>
						</div>
						

						<div class="col-md-3 s8  no-padd children form-group mtm-20">


							{(() => {
							if (this.state.checked==true) {
								return (
									<>
									<Checkbox
										onClick={this.toggleUnChecked.bind(this)}
										checked="checked"
										id="all"
									>
									<label for="all" className="select-all">UNSELECT All </label>
									</Checkbox>
									</>
								)
							}
							else{
								return (
									<>
									<Checkbox
										onClick={this.toggleChecked.bind(this)}
										checked=""
										id="all"
									>
									<label for="all" className="select-all">SELECT All </label>
									</Checkbox>
									</>
								)
							}
						})()}

						</div>
						
						<div class="col-md-2 s4 text-center attendance pl-0 form-group">

							{(() => {
							if ((this.state.permission.find(element => element == 58)) || this.state.user_type == 'admin' || this.state.user_type == 'school') {
								return (
								<>
								  <Button type="default" onClick={this.DocumentReport} loading={this.state.docx_loading}   className="btn btn-primary new-btn " style={{'margin-bottom':'8px'}}> <DownloadOutlined /> Download Report</Button>
								</>
								)
							}
							})()}
						</div>
						
						</div>
						</div>

					</div>
				</div>
				</div>
			</div>
			</div>
			<div class="col-md-12 m12 no-padd">
            <div class="container ">
			   <div class="col-md-12 m12 mb-20 card-content iq-card atend ">

			   <div class="col-md-12 mt-10 s12 center no-padd">
						<p class="atn-label bg-white color-1 br-left10">Total<span>{this.state.total_student}</span></p>
						<p class="atn-label bg-white in-color">Present<span>{this.state.total_in}</span></p>
						<p class="atn-label bg-white out-color hidden">Out<span>{this.state.total_out}</span></p>
						<p class="atn-label bg-white halfday-color">Halfday<span>{this.state.total_halfday}</span></p>
						<p class="atn-label bg-white absent-color">Absent<span>{this.state.total_absent}</span></p>
						<p class="atn-label  bg-white leave-color br-right10">Leave<span>{this.state.total_leave}</span></p>
			   </div>

			   <div class="col-md-12 mb-20 center no-padd attnd">
			    {/* <Affix offsetTop={70} onChange={affixed => console.log(affixed)}>  */}

					<Button className={`att-btn btn btn-primary new-btn right-bar-btn bg-green `} onClick={this.handleSubmit_in}>PRESENT</Button>

					
					
					<Button className={`att-btn btn btn-primary new-btn  bg-orange `} onClick={this.handleSubmit_halfday}>HALF DAY</Button>
					
					<Button className={`att-btn btn btn-primary new-btn  bg-red `} onClick={this.handleSubmit_absent}>ABSENT</Button>

					<Button className={`att-btn btn btn-primary new-btn  right-bar-btn `} onClick={this.handleSubmit_leave}>LEAVE</Button>

					<Button className={`att-btn btn btn-primary new-btn  bg-orange `} onClick={this.handleSubmit_unmark}>UNMARK</Button>
					
					

				{/* </Affix>  */}
				</div>
                  <section class="invoice-list-wrapper section food">
					<div class="children bg-blue attendance mh-500 form-group">

						<div class="row child-att">
						   {this.state.school_list.map((list) => (
						   <>
						   <div class="col-md-2">
							{(() => {
								if (list.check_absent =='1') {
								return (
										<span class="absent-text" onClick={this.showModaltimeline.bind(this,list.id)}>Follow up with Parent </span>
									   )
								}
							})()}
							
						   <Checkbox
								name="checked_id[]"
								value={list.id}
								id={list.id}
								checked={this.state.checkedBoxes.find((ch) => ch === list.id)}
								onChange={(e) => this.handleCheckbox(e, list.id)}

							>
						   <label for={list.id} class="iq-card w-m checked">
						   <div class="center">
						    
						   {(() => {

								if (list.image !='') {
								return (
										<img src={list.image} class="atd-img" /> 
									   )
								}else{
								return (
										<img src={person} class="atd-img" /> 
									   )
								}
							})()}
						   <span class="stu-name">{list.first_name} {list.last_name}</span>
						   
						   </div>
						   {(() => {

								if (list.student_in =='1') {
								return (
										<span class="in-time in-color">Present</span>
									   )
								}
							})()}
							{(() => {

								if (list.student_out =='1') {
								return (
										<span class="in-time  out-color">Out Time : {list.out_time}</span>
									   )
								}
							})()}
							{(() => {
								if (list.student_halfday == '1') {
								return (
										<span class="in-time halfday-color">Halfday</span>
									   )
								}
							})()}
							{(() => {

								if (list.student_absent =='1') {
								return (
										<span class="in-time absent-color">Absent</span>
									   )
								}
							})()}
							{(() => {

								if (list.student_leave =='1') {
								return (
										<span class="in-time leave-color">Leave</span>
									   )
								}
							})()}
							{(() => {

								if (list.student_unmark =='1') {
								return (
										<span class="in-time unmark-color">Unmark</span>
									   )
								}
							})()}

							
						   </label>
						   </Checkbox>
						   
							
							</div>
							</>
						   ))}
						
						</div>   

						   {(() => {
								if (student_lenght == 0 && this.state.is_view == 1) {
								return (
										<h6 class="center">No Student Found</h6>
									   )
								}
							})()}
							
							{(() => {
								if (student_lenght == 0 && this.state.is_view == 0) {
								return (
										<h6 class="center">Please Wait While Loading</h6>
									   )
								}
							})()}





					</div>

                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
        </div>

		


	<Drawer
				title="Attendance Timeline"
				placement="right"
				width={400}
				closable={true}
				onClose={this.handleCanceltimeline}
				visible={this.state.timeline}
				className="mobile-drawer"
			>
			<div class="followup-model timelines">
				{this.state.timeline_details.map((list) => (	
				<Timeline.Item color="blue">
					<p class="font-blue">{list.added_date}</p>
					<div class="card-content row no-margin">
							<div class="children bg-blue timeline communication iq-card2">
								<Collapse
									bordered={false}
								  >
									<Panel header={list.title} key={list.id}>
										{(() => {  
									if (list.type =='log') {
									return (
										<>
										</>
											)
											}
											else{
												return (
													<table>
														<tr><td><b>Remark  :</b></td><td>{list.remark}</td></tr>
													</table>
											)
											}
										})()}
									</Panel>
									
								  </Collapse>
							</div>
					</div>
				</Timeline.Item >
				))}
				<div class="add_followup">
					<button className="btn btn-primary" onClick={this.addfollowModal.bind(this,this.state.enquiry_id)}><i class="ri-add-fill"></i> Add Followup</button>
				</div>
			</div>
	</Drawer>
	
	<Modal
		 title="Add Follow Up"
		 visible={this.state.addfollow}
		 className="followup-model view-Profile"
		 onOk={this.addfollowOk}
		 onCancel={this.addfollowCancel}
		>
		<div class="col col-md-12 s12 form-group">
			<input type="hidden" class="form-control" name="enquiry_id" id="enquiry_id" value={this.state.enquiry_id}/>
			<label>Remark</label>
			<TextArea
				placeholder="Your Text Goes Here !!"
				class="form-control"
				autoSize={{ minRows: 6, maxRows: 6 }}
				className=""
				onChange={this.handleSizeChange}
				value={this.state.remark}
				name="remark"
			/>
		</div>	
		<div class="col col-md-12 s12 text-center mt-20">
			<Button className="btn btn-primary" onClick={this.handleSubmit} loading={this.state.loading}>Add</Button>
		</div>
	</Modal>






         </div>
      </div>

			</div>
		)
	}
}
export default Index;
